import {createContext, useContext, useMemo} from "react";
import {useForumsSavedTopicsRequest} from "../request/api";

const SavedContext = createContext();

/**
 * Approach inspired by {@link https://blog.logrocket.com/guide-state-management-next-js/}
 */
export function SavedProvider({ children }) {
  const saveddRequest = useForumsSavedTopicsRequest(undefined, {withCredentials: true});

  const value = useMemo(
    () => ({
      saved: saveddRequest.data,
      isLoadingSaves: saveddRequest.isLoading,
      reloadSaves: saveddRequest.mutate,
      saveddError: saveddRequest.error,
    }),
    [saveddRequest]
  );

  return (
    <SavedContext.Provider value={value}>
      {children}
    </SavedContext.Provider>
  );
}

export function useSavedContext() {
  return useContext(SavedContext);
}
